import { useAppDispatch } from '../../../../store';

export const useMeasurementsInterface = () => {
    const dispatch = useAppDispatch();
    return {};
};
